import { render, staticRenderFns } from "./riskHazard.vue?vue&type=template&id=1a1f7bfa"
import script from "./riskHazard.vue?vue&type=script&lang=js"
export * from "./riskHazard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1f7bfa')) {
      api.createRecord('1a1f7bfa', component.options)
    } else {
      api.reload('1a1f7bfa', component.options)
    }
    module.hot.accept("./riskHazard.vue?vue&type=template&id=1a1f7bfa", function () {
      api.rerender('1a1f7bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskHazard.vue"
export default component.exports